import React from "react";
import { Phone, Mail, MapPin } from "lucide-react";
import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function Contact() {
  const { ref, visible } = useScrollReveal();

  const contacts = [
    {
      icon: Phone,
      label: "Cell",
      value: "479-422-7180",
      href: "tel:+14794227180"
    },
    {
      icon: Phone,
      label: "Office",
      value: "479-365-0222",
      href: "tel:+14793650222"
    },
    {
      icon: Mail,
      label: "Email",
      value: "naturalconcrete.contruction@gmail.com",
      href: "mailto:naturalconcrete.contruction@gmail.com"
    },
    {
      icon: MapPin,
      label: "Service Area",
      value: "Northwest Arkansas & Surrounding Areas",
      href: null
    }
  ];

  return (
    <section id="contact" className="bg-[hsl(var(--poured))] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div
          ref={ref}
          className={`text-center max-w-3xl mx-auto mb-14 transition-all duration-700 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
          }`}
        >
          <div className="inline-flex items-center gap-2 mb-4">
            <div className="w-8 h-0.5 bg-[#434951]" />
            <span className="section-label text-[#194d32] text-base">
              CONTACT
            </span>
            <div className="w-8 h-0.5 bg-[#434951]" />
          </div>
          <h2 className="headline text-[hsl(var(--navy))] text-4xl sm:text-5xl md:text-6xl mb-2">
            Naturals Concrete Construction
          </h2>
        </div>

        <div
          className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 transition-all duration-700 delay-150 ${
            visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
          }`}
        >
          {contacts.map((c, i) => {
            const Icon = c.icon;
            const inner = (
              <>
                <div className="flex items-center justify-center w-14 h-14 rounded-sm border border-[hsl(var(--accent))]/20 mb-4 bg-[#194d32]/[0.1]">
                  <Icon size={26} className="text-[#194d32]" />
                </div>
                <div className="section-label text-[hsl(var(--charcoal))]/60 mb-1">
                  {c.label}
                </div>
                <div className="font-heading text-lg text-[hsl(var(--navy))] tracking-wide break-all">
                  {c.value}
                </div>
              </>
            );

            return c.href ? (
              <a
                key={i}
                href={c.href}
                className="bg-white border border-[hsl(var(--concrete))] rounded-sm p-6 text-center hover:shadow-xl hover:-translate-y-1 hover:border-[hsl(var(--accent))] transition-all focus-ring"
              >
                {inner}
              </a>
            ) : (
              <div
                key={i}
                className="bg-white border border-[hsl(var(--concrete))] rounded-sm p-6 text-center"
              >
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}